import React from "react";
import {Grid} from "@material-ui/core";
import {SideMenu} from "./side_menu/SideMenu";
import CssBaseline from "@material-ui/core/CssBaseline";
import IconButton from "@material-ui/core/IconButton";
import Hidden from "@material-ui/core/Hidden";
import DehazeIcon from '@material-ui/icons/Dehaze';
import Toolbar from "@material-ui/core/Toolbar";
import "../assets/scss/Static.scss";
import "../assets/scss/Layout.scss";
import auth from "../auth/auth";
import Routes from "../routes/Routes";
import {LanguageBtn} from "../components/LanguageBtn";
import {CustomAlertModal} from "../components/CustomAlertModal";
import Button from "@material-ui/core/Button";
import ExitToAppIcon from '@material-ui/icons/ExitToApp';
import {getLabel} from "../localization/MainLocalization";

export const Layout = props => {

    const [open, setOpen] = React.useState(false);


    function handleToggleDrawer() {
        setOpen(!open)
    }

    return (
        <>
            <CssBaseline/>
            <Grid container className="root bg-light">
                <CustomAlertModal/>

                <SideMenu open={open} handleToggleDrawer={handleToggleDrawer}/>

                <Grid item xs={12} sm={8} md={9} lg={10} className="sub-root">
                    <Toolbar className='AppBar'>

                        <Hidden smUp>
                            <IconButton onClick={handleToggleDrawer} className='text-white'>
                                <DehazeIcon/>
                            </IconButton>
                        </Hidden>


                        <div className='mr-auto'/>

                        <LanguageBtn/>

                        <Button className="text-white"
                            onClick={() => auth.logout()}
                        startIcon={<ExitToAppIcon/>}
                        >
                            {getLabel("logout")}
                        </Button>


                    </Toolbar>


                    {/*<div className='container-header'/>*/}

                    <main className="container-body">

                        {/*// Page Content*/}
                        <Routes/>

                    </main>

                </Grid>

            </Grid>
        </>
    );
}